// jquerySetup.js
import $ from 'jquery';
window.$ = window.jQuery = $;
